import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { map, takeUntil } from 'rxjs/operators';

import {
  EntityConnectionWithTagsFragment, GetTagGroups2GQL, TagGroupInfoFragment
} from 'generated/graphql';

import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';
import {
  ApplyTagWithFieldSelectDialog
} from 'field-shared/dialogs/apply-tag-with-field-select/apply-tag-with-field-select.dialog';
import { filterGroupCategoriesByArchiveStatus } from 'field-shared/field-helper-functions';

@Component({
  selector: 'app-entity-connection-applied-tags',
  templateUrl: './entity-connection-applied-tags.component.html',
  styleUrls: ['./entity-connection-applied-tags.component.scss']
})
export class EntityConnectionAppliedTagsComponent extends WithDisposableSubject() implements OnInit {
  @Input() campaignId: string;
  @Input() entityConnectionTypeId: string;
  @Input() entityConnection: EntityConnectionWithTagsFragment;

  tagGroups: TagGroupInfoFragment[];
  constructor(
    private _cd: ChangeDetectorRef,
    private _dialog: MatDialog,
    private _getTagGroups2: GetTagGroups2GQL
  ) {
    super();
  }

  ngOnInit(): void {
    this._getTagGroupsWithCategoryForConnectionType(
      this.campaignId,
      this.entityConnectionTypeId
    ).pipe(
      takeUntil(this.disposer)
    ).subscribe((groups) => {
      this.tagGroups = groups;
      this._cd.markForCheck();
    });
  }

  openAddConnectionInfoDialog() {
    ApplyTagWithFieldSelectDialog.open(this._dialog, {
      data: {
        targetType: 'EntityConnectionType',
        targetTypeId: this.entityConnectionTypeId,
        targetId: this.entityConnection?.id,
        campaignId: this.campaignId
      }
    });
  }

  private _getTagGroupsWithCategoryForConnectionType(
    campaignId: string,
    entityConnectionTypeId: string
  ) {
    return this._getTagGroups2.watch({
      targetType: 'EntityConnectionType',
      targetTypeId: entityConnectionTypeId,
      campaignId,
    }).valueChanges.pipe(
      map(({ data }) => data.getTagGroups.nodes),
      map(groups => filterGroupCategoriesByArchiveStatus(groups, 'Active')
        .filter(c => c.categories.length > 0))
    );
  }
}
